import { useCallback, useEffect, useState } from 'react';
import { getPurchaseById } from '../api';

const isPreviewablePurchase = (purchase) => (
  Boolean(purchase)
  && !purchase.isDeleted
  && String(purchase.saleStatus || '').toLowerCase() === 'open'
  && !purchase.isPaid
);

const useActivePurchasePreview = ({
  branchId,
  activePurchaseId,
  enabled,
  refreshToken,
}) => {
  const [purchase, setPurchase] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadPurchase = useCallback(async () => {
    if (!enabled || !branchId || !activePurchaseId) {
      setPurchase(null);
      setLoading(false);
      setError(null);
      return null;
    }

    setLoading(true);
    setError(null);
    try {
      const nextPurchase = await getPurchaseById(branchId, activePurchaseId);
      if (!isPreviewablePurchase(nextPurchase)) {
        setPurchase(null);
        return null;
      }
      setPurchase(nextPurchase);
      return nextPurchase;
    } catch (err) {
      console.error('Error loading active purchase preview:', err);
      setError(err);
      setPurchase(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [activePurchaseId, branchId, enabled]);

  useEffect(() => {
    loadPurchase();
  }, [loadPurchase, refreshToken]);

  useEffect(() => {
    if (!enabled || !activePurchaseId) {
      setPurchase(null);
      setError(null);
      setLoading(false);
    }
  }, [activePurchaseId, enabled]);

  return { purchase, loading, error, reload: loadPurchase };
};

export default useActivePurchasePreview;
